import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, FontWeight } from '../../../../theme';
import { styleWhenTrue } from '../../../../utils';

import { PhotoSliderItemData } from './photoSlider.types';
import LocalArrowIcon from './images/arrow.inline.svg';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ArrowIcon = styled(LocalArrowIcon)`
  width: 20px;
  g {
    fill: ${Color.primary};
  }
`;

export const Photo = styled.img`
  max-width: calc(100% - 120px);
  max-height: calc(100% - 160px);
`;

export const PhotoLabelContainer = styled.div`
  color: ${Color.primary};
  font-size: 18px;
  letter-spacing: 0;
  line-height: 25px;
  width: 100%;
  position: absolute;
  bottom: 60px;
  left: 60px;
`;

export const PhotoHeader = styled.div``;

export const PhotoDescription = styled.div`
  font-weight: ${FontWeight.Medium};
`;

export const PhotoSliderItem = styled.div<PhotoSliderItemData>`
  position: absolute;
  width: calc(100% - 120px);
  height: calc(100% - 160px);
  padding: 60px;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: opacity 0.7s;
  opacity: 0;
  pointer-events: none;
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const ExternalLink = styled.a``;

export const ArrowContainer = styled.div`
  height: 54px;
  width: 54px;
  position: absolute;
  top: 0;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${Color.tertiary};
`;
